import { Component } from "@angular/core";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";

@Component({
    selector: "app-frequently-asked-questions",
    imports: [AppLayoutComponent],
    templateUrl: "./frequently-asked-questions.component.html",
    styleUrl: "./frequently-asked-questions.component.scss"
})
export class FrequentlyAskedQuestionsComponent {}
